/* @ngInject */
function productsService (ConnectorWebService, CONSTANTS, Utils) {
  const service = {
    getProductsForAdmin,
    getProductsForUsers,
    getProductById,
    getProductBySlug,
    fnSearchForProducts,
    formatterProductSize,
    groupByCategory,
    createProduct,
    editProduct,
    getTemplatesFromProduct,
    getTemplatesDetailsFromProduct,
    countProducts,
    getProductsBySection,
    getAllProducts,
    getDefaultProducts,
    verifyIfProductExists
  }
  return service

  function _getProducts (isAdmin, top, skip, sort, sectionId) {
    let url = CONSTANTS.URL_EXPANDED_PRODUCTS_ADMIN

    if (!isAdmin) {
      url = CONSTANTS.URL_EXPANDED_PRODUCTS
    }

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }
    if (sort) {
      url = Utils.fnAddQueryToUrl(url, { $sort: sort.name, $order: sort.order })
    }
    if (sectionId) {
      url = Utils.fnAddQueryToUrl(url, { artSectionId: sectionId })
    }

    return ConnectorWebService.get(url)
  }

  function countProducts () {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_COUNT)
    return ConnectorWebService.get(url)
  }

  function getProductsForAdmin (top, skip, sort) {
    return _getProducts(true, top, skip, sort)
  }

  function getProductsForUsers (top, skip, sort, sectionId) {
    return _getProducts(false, top, skip, sort, sectionId)
  }

  function getProductById (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_ID, [id])
    return ConnectorWebService.get(url)
  }

  function getProductBySlug (slug) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_SLUG, [slug])
    return ConnectorWebService.get(url)
  }

  function fnSearchForProducts (searchObj, fnSucessCallback, fnErrorCallback) {
    return ConnectorWebService.post(CONSTANTS.URL_PRODUCTS_SEARCH, searchObj)
  }

  /**
   * Receives the product and returns its formatted size.
   * @param {Object} oProduct: Product
   * @returns {String} Formatted product size
   */
  function formatterProductSize (oProduct) {
    if (oProduct && oProduct.description) {
      return oProduct.description
    } else if (oProduct.slug === 'custom-size') {
      return ''
    } else if (oProduct.layers && oProduct.layers.length) {
      return oProduct.layers[0].width + oProduct.layers[0].sizeUnit + ' x ' + oProduct.layers[0].height + oProduct.layers[0].sizeUnit
    } else if (oProduct.height && oProduct.width) {
      return oProduct.width + oProduct.sizeUnit + ' x ' + oProduct.height + oProduct.sizeUnit
    }
  }

  function groupByCategory (aProducts, bRemovePrintableProducts) {
    const categories = []

    aProducts.forEach(function (oProduct) {
      if (!oProduct.section) {
        return
      }

      if (bRemovePrintableProducts && oProduct.type === 'PRINTABLE') {
        return
      }

      const sectionIndex = categories.findIndex(category => category.id === oProduct.section.id)

      if (sectionIndex > -1) {
        categories[sectionIndex].products.push(oProduct)
      } else {
        categories.push({
          id: oProduct.section.id,
          title: oProduct.section.title,
          order: oProduct.section.order,
          products: [oProduct]
        })
      }
    })

    return categories
  }

  function createProduct (payload) {
    return ConnectorWebService.post(CONSTANTS.URL_PRODUCTS, payload)
  }

  function editProduct (form, id) {
    const payload = { form }
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_ID, [id])
    return ConnectorWebService.put(url, payload)
  }

  function getDefaultProducts (type, search) {
    let url = Utils.fnAddQueryToUrl(CONSTANTS.URL_PRODUCTS, { defaultProducts: true })

    if (type) {
      url = Utils.fnAddQueryToUrl(url, { type })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    return ConnectorWebService.get(url)
  }

  function getTemplatesFromProduct (id, top, skip) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_PRODUCTS_ID_TEMPLATES, [id])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getTemplatesDetailsFromProduct (id) {
    const url = Utils.fnReplaceStringParams(CONSTANTS.URL_TEMPLATES_DETAILS_BY_PRODUCT, [id])

    return ConnectorWebService.get(url)
  }

  function getProductsBySection (sectionId, top, skip) {
    let url = Utils.fnReplaceStringParams(CONSTANTS.URL_ART_COLLECTIONS_ID_COLLECTIONS, [sectionId])

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    return ConnectorWebService.get(url)
  }

  function getAllProducts (params) {
    let url = CONSTANTS.URL_PRODUCTS

    const { top, skip, type, search, defaultProducts } = params

    if (top || skip) {
      url = Utils.fnAddTopSkipQueriesToUrl(url, top, skip)
    }

    if (type) {
      url = Utils.fnAddQueryToUrl(url, { type })
    }

    if (search) {
      url = Utils.fnAddQueryToUrl(url, { search })
    }

    if (defaultProducts !== undefined) {
      url = Utils.fnAddQueryToUrl(url, { defaultProducts })
    }

    return ConnectorWebService.get(url)
  }

  function verifyIfProductExists (params) {
    let url = CONSTANTS.URL_PRODUCTS_VERIFY

    const { type, width, height } = params

    if (type) {
      url = Utils.fnAddQueryToUrl(url, { type })
    }

    if (width) {
      url = Utils.fnAddQueryToUrl(url, { width })
    }

    if (height) {
      url = Utils.fnAddQueryToUrl(url, { height })
    }

    return ConnectorWebService.get(url)
  }
}

export { productsService }
